/* eslint-disable no-extra-boolean-cast */
import { getVideoTutorialDuration } from '@components/learn/learn';
import { convertStatus } from '@components/learningPath/utils';
import { ContentType } from 'learning-panel-components';
import { coreService } from 'network-utils';

const convertVideosToContentCard = (videoTutorial: coreService.VideoTutorialData, setVideoTutorialUuid: Function) => {
    return {
        uuid: videoTutorial.uuid,
        type: 'videoTutorial' as keyof typeof ContentType,
        imageUrl: videoTutorial.imageUrl ?? `${process.env.PUBLIC_URL}/images/videoDefaultCard.svg`,
        name: videoTutorial.displayName,
        displayName: videoTutorial.displayName,
        description: videoTutorial.description,
        useOverlay: Boolean(videoTutorial.imageUrl),
        timeOrDate: videoTutorial.duration ? getVideoTutorialDuration(videoTutorial.duration) : '',
        earnedPoints: videoTutorial.earnedPoints,
        onClick: () => setVideoTutorialUuid(videoTutorial.uuid),
        status: convertStatus(videoTutorial.status),
        month: videoTutorial.month,
        tags: videoTutorial.tags?.filter(tag => !Boolean(tag.isInternal)).map(tag => tag.displayName)
    };
};

export default convertVideosToContentCard;
